import React, { useEffect, createElement } from 'react';
import { TrustBar } from './components/TrustBar';
import { HeroSection } from './components/HeroSection';
import { GalleryMarquee } from './components/GalleryMarquee';
import { LetterSection } from './components/LetterSection';
import { ProblemSection } from './components/ProblemSection';
import { TestimonialSection } from './components/TestimonialSection';
import { SolutionSection } from './components/SolutionSection';
import { MechanismSection } from './components/MechanismSection';
import { FeaturesSection } from './components/FeaturesSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FooterCTA } from './components/FooterCTA';
import { WhatsAppButton } from './components/WhatsAppButton';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    document.title = 'Techain Ad Angle';
    // Favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute('href', 'https://cdn.magicpatterns.com/uploads/ssBYQDyxSfG5W9VJMFgZF4/techainblanco.png');
    } else {
      const favicon = document.createElement('link');
      favicon.rel = 'icon';
      favicon.type = 'image/png';
      favicon.href = 'https://cdn.magicpatterns.com/uploads/ssBYQDyxSfG5W9VJMFgZF4/techainblanco.png';
      document.head.appendChild(favicon);
    }
    // SEO Meta Tags
    const metaTags: Record<string, string> = {
      description: 'Generá +100 creativos estáticos que venden en solo 10 minutos. Techain Ad Angle es el sistema de volumen extremo para Meta Ads de productos digitales.',
      keywords: 'creativos meta ads, generador de creativos, ads para infoproductos, testing de creativos, ángulos de venta, media buying, ROAS, publicidad digital, Techain',
      author: 'Techain',
      robots: 'index, follow',
      'theme-color': '#8B5CF6',
      // Open Graph
      'og:title': 'Techain Ad Angle | +100 Creativos Que Venden en 10 Minutos',
      'og:description': 'El sistema de volumen extremo para generar creativos estáticos listos para Meta Ads. Pago único, acceso de por vida.',
      'og:image': 'https://cdn.magicpatterns.com/uploads/ssBYQDyxSfG5W9VJMFgZF4/techainblanco.png',
      'og:type': 'website',
      // Twitter Card
      'twitter:card': 'summary_large_image',
      'twitter:title': 'Techain Ad Angle | +100 Creativos Que Venden en 10 Minutos',
      'twitter:description': 'Generá +100 creativos estáticos que venden en solo 10 minutos. Sistema de volumen extremo para Meta Ads.',
      'twitter:image': 'https://cdn.magicpatterns.com/uploads/ssBYQDyxSfG5W9VJMFgZF4/techainblanco.png'
    };
    Object.entries(metaTags).forEach(([key, value]) => {
      const isOg = key.startsWith('og:');
      const isTwitter = key.startsWith('twitter:');
      const attr = isOg || isTwitter ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, key);
        document.head.appendChild(meta);
      }
      meta.content = value;
    });
  }, []);
  return <main className="min-h-screen bg-[#020202] text-white selection:bg-purple-500/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TrustBar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <GalleryMarquee data-id="element-4" />
      <LetterSection data-id="element-5" />
      <ProblemSection data-id="element-6" />
      <TestimonialSection data-id="element-7" />
      <SolutionSection data-id="element-8" />
      <MechanismSection data-id="element-9" />
      <FeaturesSection data-id="element-10" />
      <BonusSection data-id="element-11" />
      <PricingSection data-id="element-12" />
      <GuaranteeSection data-id="element-13" />
      <FAQSection data-id="element-14" />
      <FooterCTA data-id="element-15" />

      <WhatsAppButton data-id="element-16" />
      <StickyMobileCTA data-id="element-17" />
    </main>;
}